import { DataSchemeFilter, DataSchemeList, DataSchemeProduct, DataSchemeSingleProduct, SmartPhrase } from './types';

import { CoordinateModel } from '../../models/coordinate.model';
import { DetailProductModel, NeighborsProductsModel, ProductModel } from '../../models/products.model';
import { SetSujetCheckModel, SujetCheckModel } from '../../models/request.model';
import { AppState } from '../store';

export const productListData = (state: AppState): ProductModel[] => state.location.dataList.data?.products;

export const dataList = (state: AppState): DataSchemeList => state.location.dataList;

export const dataProductsFull = (state: AppState): DataSchemeProduct => state.location.dataProducts;

export const dataProducts = (state: AppState): ProductModel[] => state.location.dataProducts.data;

export const dataProductFull = (state: AppState): DataSchemeSingleProduct => state.location.dataProduct;

export const dataProduct = (state: AppState): DetailProductModel | null => state.location.dataProduct.data;

export const dataNeighborsProducts = (state: AppState): NeighborsProductsModel[] => state.location.dataNeighborsProducts;

export const filterData = (state: AppState): DataSchemeFilter => state.location.filter;

export const coordinateData = (state: AppState): CoordinateModel => state.location.coordinate;

export const factsheetLinkPDF = (state: AppState): string => state.location.factsheetLinkPDF as string;

export const factsheetLinkXLSX = (state: AppState): string => state.location.factsheetLinkXLSX as string;

export const factsheetLinkPPT = (state: AppState): string => state.location.factsheetLinkPPT as string;

export const bookingYear = (state: AppState): number => state.location.bookingYear;

export const smartPhrases = (state: AppState): SmartPhrase[] => state.location.smartPhrases as SmartPhrase[];

export const smartPhrasesList = (state: AppState): string[] => state.location.smartPhrasesList as string[];
export const sujetcheckAssetData = (state: AppState): SujetCheckModel =>
    state.location.sujetcheckAssetData as SujetCheckModel;

export const sujetcheckImages = (state: AppState): SetSujetCheckModel =>
    state.location.sujetcheckImages as SetSujetCheckModel;

export const searchString = (state: AppState): string => state.router.location.search;
